import request from '@/utils/request'

/**
 * 
 * 选对小工具接口
 * openXjy  代表请求open.xjy.cn域名
 */
// 商品列表(不分页)
export function productAll(data) {
  return request({
    url: '/router/product/all',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 商品已购订单
export function orderBuyList(data) {
  return request({
    url: '/router/order/buyList',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}


// 创建订单
export function createOrder(data) {
  return request({
    url: '/router/pay/createOrder',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 保存用户信息
export function saveInfo(data) {
  return request({
    url: '/router/pay/saveInfo',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 更新剩余名额
export function cancelOrder(data) {
  return request({
    url: '/router/pay/cancelOrder',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 获取已购买
export function orderGet(data) {
  return request({
    url: '/router/order/get',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 事件统计
export function evenAdd(data) {
  return request({
    url: '/router/event/add',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 获取订单
export function orderList(data) {
  return request({
    url: '/router/order/list',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 获取微信用户信息
export function userInfo(data) {
  return request({
    url: '/router/weixin/userInfo',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 验证是否以绑定手机号
export function check_bind(data) {
  return request({
    url: '/router/weixin/check_bind',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}
// 绑定手机号
export function bind_mobile(data) {
  return request({
    url: '/router/weixin/bind_mobile',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 发送短信
export function send_sms(data) {
  return request({
      url: '/admin/send_sms',
      method: 'POST',
      domain:'open.xjy.cn',
      data: data || {}
  })
}
// 检查验证码
export function check_sms(data) {
  return request({
      url: '/admin/check_sms',
      method: 'POST',
      domain:'open.xjy.cn',
      data: data || {}
  })
}

// 获取金额
export function counsellingList(data) {
  return request({
    url: '/router/counselling/list',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 提交报告
export function counsellingSetReport(data) {
  return request({
    url: '/router/counselling/setReport',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 获取报告
export function counsellingGet(data) {
  return request({
    url: '/router/counselling/get',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 咨询方案-添加
export function extensionAdd(data) {
  return request({
    url: '/router/extension/add',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 咨询方案-修改
export function extensionSave(data) {
  return request({
    url: '/router/extension/save',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 咨询方案-查询
export function extensionGet(data) {
  return request({
    url: '/router/extension/get',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}